import React from 'react'
import { observer } from 'mobx-react-lite'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import { formatNumber } from '../../../../../../../utils/Helper'
export default observer(function InfluencerDetailsHeader({ infActions }) {

  return (
    <div className="border-b-1 border-border-primary dark:border-rb-dark-mode-lighter">
      <div className="flex items-center p-5">
        <img className="w-20 h-20 rounded-full object-cover" src={infActions[0].avatar} alt="Avatar"/>
        <div className="ml-5">
          <p className='font-bold text-sm dark:text-white'>{infActions[0].auth_username}</p>
          <div className="flex mt-1">
            {infActions[0].auth_country && <div className="flex mr-4">
              {infActions[0].auth_country && getUnicodeFlagIcon(infActions[0].auth_country)}
              <p className="ml-1 dark:text-white">{infActions[0].auth_country}</p>
            </div>}
            <div className="flex">
              <p className='dark:text-white'>Reach</p>
              <p className="ml-1 text-rb-green font-bold">{formatNumber(infActions[0].reach)}</p>
            </div>
            <div className="flex ml-4">
              <p className='dark:text-white'>Eng. rate</p>
              <p className="ml-1 text-rb-green font-bold">{(infActions[0].auth_engagement_rate * 100).toFixed(2)}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})